/**
 * Espera a que el estilo del mapa esté listo para addSource/addLayer.
 * No basta con `map.once('load')`: en vistas compartidas de lote el evento `load`
 * puede haber ocurrido antes de activar una capa, mientras el estilo sigue mutando.
 */
export function waitForMapStyleReady(map, { timeoutMs = 15000 } = {}) {
  if (!map) return Promise.resolve();
  if (map.isStyleLoaded()) return Promise.resolve();

  return new Promise((resolve) => {
    let settled = false;

    const finish = () => {
      if (settled) return;
      settled = true;
      map.off('load', onLoad);
      map.off('styledata', onStyleData);
      map.off('idle', onIdle);
      resolve();
    };

    const onLoad = () => finish();
    const onStyleData = () => {
      if (map.isStyleLoaded()) finish();
    };
    const onIdle = () => {
      if (map.isStyleLoaded()) finish();
    };

    map.once('load', onLoad);
    map.on('styledata', onStyleData);
    map.on('idle', onIdle);

    if (timeoutMs > 0) {
      setTimeout(finish, timeoutMs);
    }
  });
}
